import { connect } from 'react-redux';
import LicenseListSearched from './LicenseListSearched';
import {
    getLicenseListSearchedLoader,
    getLicenseListSearched,
    getPersonListSearched,
    getPersonListSearchedLoader,
} from '../../../store/selectors/license.selectors';

const mapStateToProps = (state: any) => {
    const licenseListSearched = getLicenseListSearched(state);
    const isLoading = getLicenseListSearchedLoader(state);
    const personListSearched = getPersonListSearched(state);
    const isPersonLoading = getPersonListSearchedLoader(state);
    return { licenseListSearched, isLoading, personListSearched, isPersonLoading };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(LicenseListSearched);
